import React, {Component} from 'react';
import {styled} from '@material-ui/core/styles';
import {Box} from '@material-ui/core';
import {globalData, ADD, EDIT, VIEW, NORMAL, CHILD, CLIENT, SPOUSE} from '../../../../common/common';
import {clone, getAge} from '../../../../common/utils';
import InputDO from '../Inputs/InputDO';
import Input1 from '../Inputs/Input1';
import Input2 from '../Inputs/Input2';
import Input3 from '../Inputs/Input3';
import Input4 from '../Inputs/Input4';
import Input5 from '../Inputs/Input5';
import Input6 from '../Inputs/Input6';
import Input7 from '../Inputs/Input7';
import Input8 from '../Inputs/Input8';
import Input9 from '../Inputs/Input9';
import Input10 from '../Inputs/Input10';
import Input11 from '../Inputs/Input11';
import Input12 from '../Inputs/Input12';
import Input13 from '../Inputs/Input13';
import Input14 from '../Inputs/Input14';
import Input15 from '../Inputs/Input15';
import Input16 from '../Inputs/Input16';
import Input17 from '../Inputs/Input17';
import Input18 from '../Inputs/Input18';
import Input19 from '../Inputs/Input19';
import Input20 from '../Inputs/Input20';
import InputRichText from '../Inputs/InputRichText';

const Root = styled(Box)({
    width: '100%',
    '& .contentTitle': {
        fontSize: '16px',
        // fontWeight: 'bold',
        color: '#212C31',
    },
    '& .blankTip': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#6f7273',
        height: '430px',
    },
    '& .wapper': {
        padding: '10px 15px',
        cursor: 'pointer',
        '& .icon': {
            visibility: 'hidden',
        },
    },
    '& .wapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
    },
    '& .wapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
    },
})

class EstateContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            note: "",
            allData: {},
            btnName: this.btnName(this.props.state)
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.setToDoc = this.setToDoc.bind(this);
        this.setToAllData = this.setToAllData.bind(this);
        this.updateInfoToAllData = this.updateInfoToAllData.bind(this);
        this.uploadChildNormalToAllData = this.uploadChildNormalToAllData.bind(this);
        this.delChildToAllData = this.delChildToAllData.bind(this);
        this.doNext = this.doNext.bind(this);
    }

    render() {
        const {
            name,
            note,
            allData,
        } = this.state;
        const {menuData, detailsData, menuIndex, dragData, state, firstName} = this.props;
        const contentView = () => {
            console.log(menuIndex)
            if (menuIndex === 0) {
                // return <InputDO
                //     name={name}
                //     note={note}
                //     ref={(child) => { this.input_doc = child }}
                //     setToDoc={this.setToDoc}
                // />
                return <div><br/>
                    <div>Hello {firstName},</div>
                    <div>Thank you for reaching out to MT Law regarding the preparation of your estate planning
                        documents. We look forward to working closely with you to accomplish your goals in securing
                        your family’s future.
                    </div>
                    <br/>
                    <div>
                        In order to initiate this process, please fill out this questionnaire.
                        It will ask you and your spouse to list the people you wish to serve the following
                        roles:
                    </div>
                    <ul>
                        <li><strong>Executor</strong> - this person is tasked with seeing to distribution of any property left in your
                            will.
                        </li>
                        <li><strong>Guardian</strong> - this person will assume guardianship of minor children until they turn 18.</li>
                        <li><strong>General Power of Attorney</strong> - this person will manage your financial matters should you
                            become incapacitated and unable to effectively manage your affairs yourself.
                        </li>
                        <li><strong>Health-Care Agent</strong> - this person will be allowed to make healthcare decisions for you if
                            you become unable to make or communicate those decisions yourself.
                        </li>
                        <li><strong>Living Will</strong> - the person listed here will be tasked with ensuring that you receive your
                            desired medical treatment in the event that you are no longer able to express informed
                            consent.
                        </li>
                        <li><strong>HIPPA Information Release Form</strong> - this form allows an appointed person or party to
                            share specific health information with another person or group.
                        </li>
                        <li><strong>Trustee</strong> - this person will manage your trust after your death and see to the distribution of
                            your property and assets. By creating a trust, you can avoid the lengthy probate process
                            that is required when distributing your assets and property exclusively through a will.
                        </li>
                        <li><strong>Emergency Guardianship</strong> - this document requests that a certain individual be allowed
                            to care for your child while you are unable to, due to incapacitation or some other reason.
                        </li>
                    </ul>
                    <div>
                        Once we receive your information and completed questionnaire, preparing your estate planning
                        documents should take between two and four weeks.
                    </div>
                </div>

            } else if (menuIndex === 1) {
                return <Input1
                    state={state}
                    data={allData["INFO"]}
                    ref={(child) => {
                        this.input_1 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                />
            } else if (menuIndex === 2) {
                return <Input2
                    state={state}
                    data={allData["Chi"]}
                    ref={(child) => {
                        this.input_2 = child
                    }}
                    setToAllData={this.setToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                    delChildToAllData={this.delChildToAllData}
                />
            } else if (menuIndex === 3) {
                return <Input8
                    state={state}
                    data={allData["C.W.S.P.R"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_8 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 4) {
                return <Input4
                    state={state}
                    data={allData["Gu"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_4 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 5) {
                return <Input5
                    state={state}
                    data={allData["POA"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_5 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 6) {
                return <Input6
                    state={state}
                    data={allData["HEA"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_6 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 7) {
                return <Input7
                    state={state}
                    data={allData["LW"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_7 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 8) {
                // return <Input8
                //     state={state}
                //     data={allData["C.W.S.P.R"]}
                //     dataINFO={allData["INFO"]}
                //     dragData={dragData}
                //     ref={(child) => { this.input_8 = child }}
                //     setToAllData={this.setToAllData}
                //     updateInfoToAllData={this.updateInfoToAllData}
                //     uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                // />
            } else if (menuIndex === 9) {
                return <Input9
                    state={state}
                    data={allData["C.F.S.P.R"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_9 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 10) {
                return <Input10
                    state={state}
                    data={allData["HIPAA"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_10 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 11) {
                return <Input16
                    state={state}
                    data={allData["S.W.S.P.R"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_16 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 12) {
                return <Input12
                    state={state}
                    data={allData["S.Gu"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_12 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 13) {
                return <Input13
                    state={state}
                    data={allData["S.POA"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_13 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 14) {
                return <Input14
                    state={state}
                    data={allData["S.HEA"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_14 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 15) {
                return <Input15
                    state={state}
                    data={allData["S.LW"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_15 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 16) {
                // return <Input16
                //     state={state}
                //     data={allData["S.W.S.P.R"]}
                //     dataINFO={allData["INFO"]}
                //     dragData={dragData}
                //     ref={(child) => { this.input_16 = child }}
                //     setToAllData={this.setToAllData}
                //     updateInfoToAllData={this.updateInfoToAllData}
                //     uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                // />
            } else if (menuIndex === 17) {
                return <Input17
                    state={state}
                    data={allData["S.F.S.P.R"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_17 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 18) {
                return <Input18
                    state={state}
                    data={allData["S.HIPAA"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_18 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 19) {
                return <Input19
                    state={state}
                    data={allData["TRUSTEE"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_19 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 20) {
                return <InputRichText
                    state={state}
                    data={allData["D.T"]}
                    ref={(child) => {
                        this.inputRichText = child
                    }}
                    setToAllData={this.setToAllData}
                />
            } else if (menuIndex === 21) {
                return <Input20
                    state={state}
                    data={allData["E.Gu"]}
                    dataINFO={allData["INFO"]}
                    dragData={dragData}
                    ref={(child) => {
                        this.input_20 = child
                    }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            }
        }
        return (
            <Root>
                <div className="contentTitle" dangerouslySetInnerHTML={{__html: detailsData[menuIndex]}}></div>
                {contentView()}
            </Root>
        )
    }

    componentDidMount() {
        const {contentData} = this.props;
        this.initData(contentData);
    }

    componentDidUpdate(prevProps) {
        const {
            contentData,
        } = this.props;
        if (prevProps.contentData !== contentData) {
            if (contentData) {
                this.initData(contentData);
            }
        }
    }

    initData(contentData) {
        const {state} = this.props;
        if (state === VIEW || state === EDIT) {
            this.setState({
                allData: contentData
            })
            let obj = contentData["Chi"];
            let haveNonage = false;
            if (!obj) return;
            for (const iterator of obj) {
                const age = getAge(iterator["DOB"])
                if (age < 18) {
                    haveNonage = true;
                }
            }
            globalData.haveNonage = haveNonage;
        } else {
            globalData.haveNonage = true;
        }
    }

    handleCancel() {
        this.props.handleCancel();
    }

    handleClick(e, index) {
        this.setState(() => ({
            menuIndex: index
        }))
    }

    setToAllData(name, value, callback = null) {
        const {allData} = this.state;
        allData[name] = value;
        if (name === "INFO") {
            allData["INFOS"] = this.extractInfoToArr(value);
            allData["TRUSTEE"] = this.extractInfoToArr(value);
        } else if (name === "Chi") {
            this.checkHaveNonage(allData["Chi"]);
        }
        this.setState({
            allData
        }, () => {
            if (callback) callback();
            this.props.handleChange(name, value);
        })
    }

    //update child or normal
    uploadChildNormalToAllData(value) {
        const allData = clone(this.state.allData);
        for (const key in allData) {
            if (Object.hasOwnProperty.call(allData, key)) {
                const arr = allData[key];
                if (arr instanceof Array) {
                    for (const obj of arr) {
                        if (obj.type === value.type && obj.id === value.id) {
                            Object.assign(obj, value);
                            if (obj.hasOwnProperty("N.")) {
                                obj[".CHO.N."] = value["N."];
                                obj[".CHO.AddrNPho"] = value["AddrNPho"];
                            }
                        }
                    }
                }
            }
        }
        this.checkHaveNonage(allData["Chi"]);
        console.log("uploadChildNormalToAllData alldata", allData);
        this.setState({
            allData
        }, () => {
            this.props.handleChange("", value);
        })
    }

    delChildToAllData(id) {
        const allData = clone(this.state.allData);
        for (const key in allData) {
            if (Object.hasOwnProperty.call(allData, key)) {
                const arr = allData[key];
                if (arr instanceof Array) {
                    for (const obj of arr) {
                        if (obj.id === id) {
                            const index = arr.indexOf(obj);
                            arr.splice(index, 1);
                        }
                    }
                }
            }
        }
        this.setState({
            allData
        }, () => {
            this.props.handleChange("", null);
        })
    }

    updateInfoToAllData() {
        const allData = clone(this.state.allData);
        for (const key in allData) {
            if (Object.hasOwnProperty.call(allData, key)) {
                const arr = allData[key];
                if (key !== "INFO") {
                    for (const obj of arr) {
                        //根据"type"字段判断每项中是否含有Client或spouse信息
                        if (Object.hasOwnProperty.call(obj, "type")) {
                            if (obj.type === CLIENT) {
                                const clientInfo = globalData.clientInfo;
                                obj[".CHO.Addr"] = clientInfo[".CHO.Addr"];
                                obj[".CHO.AddrNPho"] = clientInfo[".CHO.AddrNPho"];
                                obj[".CHO.Em."] = clientInfo[".CHO.Em."];
                                obj[".CHO.N."] = clientInfo[".CHO.N."];
                                obj[".CHO.R.C."] = clientInfo[".CHO.R.C."];
                                obj["P.H.Pho"] = clientInfo["P.H.Pho"];
                                obj["P.W.Pho"] = clientInfo["P.W.Pho"];
                                obj["rc"] = clientInfo["rc"];
                                obj["relation"] = clientInfo["relation"];
                            } else if (obj.type === SPOUSE) {
                                const spouseInfo = globalData.spouseInfo;
                                obj[".CHO.Addr"] = spouseInfo[".CHO.Addr"];
                                obj[".CHO.AddrNPho"] = spouseInfo[".CHO.AddrNPho"];
                                obj[".CHO.Em."] = spouseInfo[".CHO.Em."];
                                obj[".CHO.N."] = spouseInfo[".CHO.N."];
                                obj[".CHO.R.C."] = spouseInfo[".CHO.R.C."];
                                obj["S.H.Pho"] = spouseInfo["S.H.Pho"];
                                obj["S.W.Pho"] = spouseInfo["S.W.Pho"];
                                obj["rc"] = spouseInfo["rc"];
                                obj["relation"] = spouseInfo["relation"];
                            }
                        }
                    }
                }
            }
        }
        console.log("updateInfoToAllData alldata", allData);
        this.setState({
            allData
        })
    }

    extractInfoToArr(data) {
        //phone;unit;street;city;state;zipcode
        let addrObjP = data["P.H.Addr."];
        addrObjP["phone"] = data["P.H.Pho"];
        let addrObjS = data["S.H.Addr."];
        addrObjS["phone"] = data["S.H.Pho"];
        let rcP = (data["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        let rcS = (data["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
        const arr = [{
            ".CHO.N.": data["S.F.Name"],
            ".CHO.R.C.": rcS,
            ".CHO.AddrNPho": addrObjS,
            "id": "2",
            "type": SPOUSE,
        }, {
            ".CHO.N.": data["P.F.Name"],
            ".CHO.R.C.": rcP,
            ".CHO.AddrNPho": addrObjP,
            "id": "1",
            "type": CLIENT,
        }]
        return arr;
    }

    checkHaveNonage(chiArr) {
        if (!chiArr) return;
        let haveNonage = false;
        for (const obj of chiArr) {
            if (getAge(obj["DOB"]) < 18) {
                haveNonage = true;
            }
        }
        globalData.haveNonage = haveNonage;
    }

    setToDoc(name, value) {
        this.setState(() => ({
            [name]: value
        }))
    }

    doNext() {
        const {menuIndex} = this.props;
        if (menuIndex === 0) {
            // return this.input_doc.doNext();
            return true;
        } else if (menuIndex === 1) {
            return this.input_1.doNext();
        } else if (menuIndex === 2) {
            return this.input_2.doNext();
        } else if (menuIndex === 3) {
            return this.input_8.doNext();
        } else if (menuIndex === 4) {
            return this.input_4.doNext();
        } else if (menuIndex === 5) {
            return this.input_5.doNext();
        } else if (menuIndex === 6) {
            return this.input_6.doNext();
        } else if (menuIndex === 7) {
            return this.input_7.doNext();
        } else if (menuIndex === 8) {
            return this.input_8.doNext();
        } else if (menuIndex === 9) {
            return this.input_9.doNext();
        } else if (menuIndex === 10) {
            return this.input_10.doNext();
        } else if (menuIndex === 11) {
            return this.input_16.doNext();
        } else if (menuIndex === 12) {
            return this.input_12.doNext();
        } else if (menuIndex === 13) {
            return this.input_13.doNext();
        } else if (menuIndex === 14) {
            return this.input_14.doNext();
        } else if (menuIndex === 15) {
            return this.input_15.doNext();
        } else if (menuIndex === 16) {
            return this.input_16.doNext();
        } else if (menuIndex === 17) {
            return this.input_17.doNext();
        } else if (menuIndex === 18) {
            return this.input_18.doNext();
        } else if (menuIndex === 19) {
            return this.input_19.doNext();
        } else if (menuIndex === 20) {
            return this.inputRichText.doNext();
        } else if (menuIndex === 21) {
            return this.input_20.doNext();
        }
    }

    getData() {
        const {
            name,
            note,
            allData
        } = this.state;
        let obj = {
            name,
            note,
            content: allData
        }
        return obj;
    }

    getContentRectData() {
        const {menuIndex} = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_8.getContentRectData();
        } else if (menuIndex === 4) {
            return this.input_4.getContentRectData();
        } else if (menuIndex === 5) {
            return this.input_5.getContentRectData();
        } else if (menuIndex === 6) {
            return this.input_6.getContentRectData();
        } else if (menuIndex === 7) {
            return this.input_7.getContentRectData();
        } else if (menuIndex === 8) {
            return this.input_8.getContentRectData();
        } else if (menuIndex === 9) {
            return this.input_9.getContentRectData();
        } else if (menuIndex === 10) {
            return this.input_10.getContentRectData();
        } else if (menuIndex === 11) {
            return this.input_16.getContentRectData();
        } else if (menuIndex === 12) {
            return this.input_12.getContentRectData();
        } else if (menuIndex === 13) {
            return this.input_13.getContentRectData();
        } else if (menuIndex === 14) {
            return this.input_14.getContentRectData();
        } else if (menuIndex === 15) {
            return this.input_15.getContentRectData();
        } else if (menuIndex === 16) {
            return this.input_16.getContentRectData();
        } else if (menuIndex === 17) {
            return this.input_17.getContentRectData();
        } else if (menuIndex === 18) {
            return this.input_18.getContentRectData();
        } else if (menuIndex === 19) {
            return this.input_19.getContentRectData();
        } else if (menuIndex === 20) {
        } else if (menuIndex === 21) {
            return this.input_20.getContentRectData();
        }
        return null;
    }

    handleCollision() {
        const {menuIndex} = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_8.handleCollision();
        } else if (menuIndex === 4) {
            return this.input_4.handleCollision();
        } else if (menuIndex === 5) {
            return this.input_5.handleCollision();
        } else if (menuIndex === 6) {
            return this.input_6.handleCollision();
        } else if (menuIndex === 7) {
            return this.input_7.handleCollision();
        } else if (menuIndex === 8) {
            return this.input_8.handleCollision();
        } else if (menuIndex === 9) {
            return this.input_9.handleCollision();
        } else if (menuIndex === 10) {
            return this.input_10.handleCollision();
        } else if (menuIndex === 11) {
            return this.input_16.handleCollision();
        } else if (menuIndex === 12) {
            return this.input_12.handleCollision();
        } else if (menuIndex === 13) {
            return this.input_13.handleCollision();
        } else if (menuIndex === 14) {
            return this.input_14.handleCollision();
        } else if (menuIndex === 15) {
            return this.input_15.handleCollision();
        } else if (menuIndex === 16) {
            return this.input_16.handleCollision();
        } else if (menuIndex === 17) {
            return this.input_17.handleCollision();
        } else if (menuIndex === 18) {
            return this.input_18.handleCollision();
        } else if (menuIndex === 19) {
            return this.input_19.handleCollision();
        } else if (menuIndex === 20) {
        } else if (menuIndex === 21) {
            return this.input_20.handleCollision();
        }
    }

    handleLeave() {
        const {menuIndex} = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_8.handleLeave();
        } else if (menuIndex === 4) {
            return this.input_4.handleLeave();
        } else if (menuIndex === 5) {
            return this.input_5.handleLeave();
        } else if (menuIndex === 6) {
            return this.input_6.handleLeave();
        } else if (menuIndex === 7) {
            return this.input_7.handleLeave();
        } else if (menuIndex === 8) {
            return this.input_8.handleLeave();
        } else if (menuIndex === 9) {
            return this.input_9.handleLeave();
        } else if (menuIndex === 10) {
            return this.input_10.handleLeave();
        } else if (menuIndex === 11) {
            return this.input_16.handleLeave();
        } else if (menuIndex === 12) {
            return this.input_12.handleLeave();
        } else if (menuIndex === 13) {
            return this.input_13.handleLeave();
        } else if (menuIndex === 14) {
            return this.input_14.handleLeave();
        } else if (menuIndex === 15) {
            return this.input_15.handleLeave();
        } else if (menuIndex === 16) {
            return this.input_16.handleLeave();
        } else if (menuIndex === 17) {
            return this.input_17.handleLeave();
        } else if (menuIndex === 18) {
            return this.input_18.handleLeave();
        } else if (menuIndex === 19) {
            return this.input_19.handleLeave();
        } else if (menuIndex === 20) {
        } else if (menuIndex === 21) {
            return this.input_20.handleLeave();
        }
    }

    handleUp() {
        const {menuIndex} = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_8.handleUp();
        } else if (menuIndex === 4) {
            return this.input_4.handleUp();
        } else if (menuIndex === 5) {
            return this.input_5.handleUp();
        } else if (menuIndex === 6) {
            return this.input_6.handleUp();
        } else if (menuIndex === 7) {
            return this.input_7.handleUp();
        } else if (menuIndex === 8) {
            return this.input_8.handleUp();
        } else if (menuIndex === 9) {
            return this.input_9.handleUp();
        } else if (menuIndex === 10) {
            return this.input_10.handleUp();
        } else if (menuIndex === 11) {
            return this.input_16.handleUp();
        } else if (menuIndex === 12) {
            return this.input_12.handleUp();
        } else if (menuIndex === 13) {
            return this.input_13.handleUp();
        } else if (menuIndex === 14) {
            return this.input_14.handleUp();
        } else if (menuIndex === 15) {
            return this.input_15.handleUp();
        } else if (menuIndex === 16) {
            return this.input_16.handleUp();
        } else if (menuIndex === 17) {
            return this.input_17.handleUp();
        } else if (menuIndex === 18) {
            return this.input_18.handleUp();
        } else if (menuIndex === 19) {
            return this.input_19.handleUp();
        } else if (menuIndex === 20) {
        } else if (menuIndex === 21) {
            return this.input_20.handleUp();
        }
    }

    handleDown() {
        const {menuIndex} = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_8.handleDown();
        } else if (menuIndex === 4) {
            return this.input_4.handleDown();
        } else if (menuIndex === 5) {
            return this.input_5.handleDown();
        } else if (menuIndex === 6) {
            return this.input_6.handleDown();
        } else if (menuIndex === 7) {
            return this.input_7.handleDown();
        } else if (menuIndex === 8) {
            return this.input_8.handleDown();
        } else if (menuIndex === 9) {
            return this.input_9.handleDown();
        } else if (menuIndex === 10) {
            return this.input_10.handleDown();
        } else if (menuIndex === 11) {
            return this.input_16.handleDown();
        } else if (menuIndex === 12) {
            return this.input_12.handleDown();
        } else if (menuIndex === 13) {
            return this.input_13.handleDown();
        } else if (menuIndex === 14) {
            return this.input_14.handleDown();
        } else if (menuIndex === 15) {
            return this.input_15.handleDown();
        } else if (menuIndex === 16) {
            return this.input_16.handleDown();
        } else if (menuIndex === 17) {
            return this.input_17.handleDown();
        } else if (menuIndex === 18) {
            return this.input_18.handleDown();
        } else if (menuIndex === 19) {
            return this.input_19.handleDown();
        } else if (menuIndex === 20) {
        } else if (menuIndex === 21) {
            return this.input_20.handleDown();
        }
    }

    isDisabled() {
        const {state} = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default EstateContent;